import React from 'react';
import ReactDOM from 'react-dom/client';

import { Chart } from 'chart.js';
import App from './App';
import { applyChartDefaults } from './config/theme';
import './styles/index.scss';

applyChartDefaults(Chart);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
